import Heading from './Heading';
import styled from 'styled-components';

const StyledHeading = styled(Heading)`
    ${(props) => {
        const element = props.size || props.element || 'h3';

        return props.theme.heading[element];
    }}
    color: ${(props) =>
        props.color ? props.color : props.theme.colours.black};
    margin-bottom: ${(props) => props.margin && props.margin};
    max-width: ${(props) => props.maxWidth && props.maxWidth};
    opacity: ${(props) => props.opacity && props.opacity};
`;

export default StyledHeading;
